var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var _a;
import React from 'react';
import styled from 'styled-components';
import { Button, BUTTON_VIEW } from "../Button";
import { Icon } from "../Icon";
import { Text, TEXT_VIEW } from "../Text";
import { STACK_ALIGN, STACK_DIRECTION, STACK_DISTRIBUTION, STACK_GAP, StackView } from "../StackView";
import { ACTION_VIEW } from './types';
import { createUIElement, FIELD_XXS, KeyCode } from "../helpers";
export var DIALOG_ACTIONS_DISTRIBUTION;
(function (DIALOG_ACTIONS_DISTRIBUTION) {
    DIALOG_ACTIONS_DISTRIBUTION["start"] = "start";
    DIALOG_ACTIONS_DISTRIBUTION["end"] = "end";
    DIALOG_ACTIONS_DISTRIBUTION["center"] = "center";
})(DIALOG_ACTIONS_DISTRIBUTION || (DIALOG_ACTIONS_DISTRIBUTION = {}));
var ButtonViews = (_a = {},
    _a[ACTION_VIEW.primary] = BUTTON_VIEW.primary,
    _a[ACTION_VIEW.secondary] = BUTTON_VIEW.secondary,
    _a[ACTION_VIEW.alternate] = BUTTON_VIEW.alternate,
    _a[ACTION_VIEW.text] = BUTTON_VIEW.text,
    _a);
var StyledButton = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    &[data-is-text-view='false'] {\n        min-width: ", ";\n    }\n"], ["\n    &[data-is-text-view='false'] {\n        min-width: ", ";\n    }\n"])), FIELD_XXS);
var ActionButton = function (_a) {
    var view = _a.view, disabled = _a.disabled, enable = _a.enable, text = _a.text, iconSrc = _a.iconSrc, onClick = _a.onClick, onKeyDown = _a.onKeyDown, dataSelectorId = _a.dataSelectorId;
    var internalDisabled = !enable && disabled;
    var ui = ButtonViews[view || ACTION_VIEW.primary] || BUTTON_VIEW.primary;
    return (React.createElement(StyledButton, { ui: ui, disabled: internalDisabled, onClick: onClick, onKeyDown: onKeyDown, "data-selector-id": dataSelectorId, "data-is-text-view": ui === BUTTON_VIEW.text ? 'true' : 'false' },
        React.createElement(StackView, { gap: STACK_GAP.s, align: STACK_ALIGN.center, distribution: iconSrc ? STACK_DISTRIBUTION.start : STACK_DISTRIBUTION.center },
            iconSrc ? React.createElement(Icon, { src: iconSrc, disabled: internalDisabled }) : null,
            React.createElement(Text, { view: TEXT_VIEW.inherit }, text))));
};
var isCustomAction = function (dialogAction) {
    return dialogAction.render !== undefined;
};
export var getDialogActions = function (_a) {
    var distribution = _a.distribution, primary = _a.primary, secondary = _a.secondary;
    if (distribution === DIALOG_ACTIONS_DISTRIBUTION.start) {
        return {
            firstDialogActions: __spreadArrays(primary),
            secondDialogActions: __spreadArrays(secondary)
        };
    }
    if (distribution === DIALOG_ACTIONS_DISTRIBUTION.end) {
        return {
            firstDialogActions: __spreadArrays(secondary),
            secondDialogActions: __spreadArrays(primary)
        };
    }
    return {
        firstDialogActions: __spreadArrays(primary),
        secondDialogActions: []
    };
};
export var DialogActions = createUIElement('DialogActions', function (_a, ref) {
    var className = _a.className, _b = _a.primary, primary = _b === void 0 ? [] : _b, _c = _a.secondary, secondary = _c === void 0 ? [] : _c, loading = _a.loading, disabled = _a.disabled, _d = _a.distribution, distribution = _d === void 0 ? DIALOG_ACTIONS_DISTRIBUTION.end : _d, onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "primary", "secondary", "loading", "disabled", "distribution", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    var _e = getDialogActions({
        distribution: distribution,
        primary: primary,
        secondary: secondary
    }), firstDialogActions = _e.firstDialogActions, secondDialogActions = _e.secondDialogActions;
    var hasSecond = !!firstDialogActions.length && distribution !== DIALOG_ACTIONS_DISTRIBUTION.center;
    var dataSelectorId = rest['data-selector-id'] || 'dialog-actions';
    return (React.createElement(StackView, __assign({}, rest, { "data-selector-id": dataSelectorId, className: "vm-DialogActions " + className, direction: STACK_DIRECTION.row, gap: STACK_GAP.m, align: STACK_ALIGN.center, distribution: distribution === DIALOG_ACTIONS_DISTRIBUTION.center
            ? STACK_DISTRIBUTION.center
            : STACK_DISTRIBUTION.end, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        firstDialogActions.map(function (dialogAction, idx) {
            if (isCustomAction(dialogAction)) {
                return (React.createElement(React.Fragment, { key: dialogAction.id || "first-custom-item-" + idx }, dialogAction.render()));
            }
            var id = dialogAction.id, testId = dialogAction.testId, text = dialogAction.text, onKeyDown = dialogAction.onKeyDown;
            return (React.createElement(ActionButton, __assign({ key: id + "-" + text + "-" + idx }, dialogAction, { onKeyDown: function (e) {
                    if (e.keyCode === KeyCode.Enter) {
                        e.stopPropagation();
                    }
                    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
                }, dataSelectorId: testId || dataSelectorId + "-second-control-" + (id || idx), disabled: disabled || loading || dialogAction.disabled })));
        }),
        hasSecond && React.createElement("div", { key: "space", style: { flex: '1' } }),
        distribution !== DIALOG_ACTIONS_DISTRIBUTION.center &&
            secondDialogActions.map(function (dialogAction, idx) {
                if (isCustomAction(dialogAction)) {
                    return (React.createElement(React.Fragment, { key: dialogAction.id || "second-custom-item-" + idx }, dialogAction.render()));
                }
                var id = dialogAction.id, text = dialogAction.text, testId = dialogAction.testId, onKeyDown = dialogAction.onKeyDown;
                return (React.createElement(ActionButton, __assign({ key: id + "-" + text + "-" + idx }, dialogAction, { disabled: disabled || loading || dialogAction.disabled, onKeyDown: function (e) {
                        if (e.keyCode === KeyCode.Enter) {
                            e.stopPropagation();
                        }
                        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
                    }, dataSelectorId: testId || dataSelectorId + "-control-" + (id || idx) })));
            })));
});
var templateObject_1;
//# sourceMappingURL=DialogActions.js.map